import { ComponentType, useContext, useMemo } from "react";

import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "./withCascadiaControlProps";
import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { computeConditionalOneOf } from "../utils";

export interface CascadiaOneOfProps extends CascadiaControlProps {
  items: { label: string; value: string; description?: string }[];
}

export function withCascadiaOneOfProps(
  Component: ComponentType<CascadiaOneOfProps>
) {
  const ComponentWithControlProps = (props: CascadiaControlProps) => {
    const { values: rootValues, schema: rootSchema } = useContext(
      CascadiaJsonFormContext
    );

    const items = useMemo(() => {
      let oneOf = props.schema.oneOf || [];
      if (rootSchema) {
        const conditionalOneOf = computeConditionalOneOf(
          rootSchema,
          rootValues,
          props.path.split(".")
        );
        if (conditionalOneOf) {
          oneOf = conditionalOneOf;
        }
      }
      return (
        oneOf
          ?.filter((oneOf) => Boolean(oneOf.const))
          .map((item) => ({
            label: item.title || item.const,
            value: item.const,
            description: item.description,
          })) || []
      );
    }, [props.schema.oneOf, rootSchema, rootValues]);

    return <Component {...props} items={items} />;
  };

  ComponentWithControlProps.displayName = Component.displayName;

  return withCascadiaControlProps(ComponentWithControlProps);
}
